import axios from 'axios';

class CurrencyService {
  constructor() {
    this.baseUrl = 'https://api.frankfurter.app';
    this.cache = new Map();
    this.cacheTimeout = 1000 * 60 * 60; // 1 heure
  }

  async getExchangeRate(fromCurrency, toCurrency) {
    const cacheKey = `${fromCurrency}-${toCurrency}`;
    const cached = this.cache.get(cacheKey);
    
    if (cached && Date.now() - cached.timestamp < this.cacheTimeout) {
      return cached.rate;
    }

    try {
      const response = await axios.get(`${this.baseUrl}/latest`, {
        params: {
          from: fromCurrency,
          to: toCurrency
        }
      });

      if (response.data && response.data.rates && response.data.rates[toCurrency]) {
        const rate = response.data.rates[toCurrency];
        this.cache.set(cacheKey, {
          rate,
          timestamp: Date.now()
        });
        return rate;
      }
      throw new Error('Taux de change non disponible');
    } catch (error) {
      console.error('Erreur lors de la récupération du taux de change:', error);
      throw error;
    }
  }

  async convertToEur(amount, fromCurrency) {
    if (!amount || !fromCurrency || fromCurrency === 'EUR') {
      return Number(amount) || 0;
    }

    try {
      const rate = await this.getExchangeRate(fromCurrency, 'EUR');
      return Number(amount) * rate;
    } catch (error) {
      console.error('Erreur lors de la conversion en EUR:', error);
      return Number(amount) || 0;
    }
  }
}

export default new CurrencyService(); 